var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step",class:{ slim: _vm.slim }},[(_vm.showHeader)?_c('div',{staticClass:"step__title"},[_c('rounded-tag',{staticClass:"step__title__number"},[_vm._v(_vm._s(_vm.number))]),_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }